import { render, staticRenderFns } from "./AligmentCustoms.vue?vue&type=template&id=4bb4ddbe&scoped=true"
import script from "./AligmentCustoms.vue?vue&type=script&lang=js"
export * from "./AligmentCustoms.vue?vue&type=script&lang=js"
import style0 from "./AligmentCustoms.vue?vue&type=style&index=0&id=4bb4ddbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4ddbe",
  null
  
)

export default component.exports